<template>

    <bottom-sheet ref="bottomsheet">

        <div class="bsds">

            <p class="text-lSemibold">{{$t('discover_key_features_before_sorting')}}</p>

            <img src="/img/discovery/foxy-swim.svg" class="swim" alt="foxy in a newsletter pool">

            <span class="text-baseMedium mt__24">{{$t('your_mission')}}</span>

            <span class="text-lSemibold color__aquamarine mt__2">{{$t('cleanup_foxys_mailbox')}}</span>

            <button class="cta-medium-primary cta-medium mt__16" @click="goDiscovery">{{$t('how_works_title')}}</button>

            <span class="text-baseMedium color__stone mt__24">{{$t('not_interested')}}</span>

            <button class="cta-medium-tertiary mt__16" @click="goLanding">{{$t('connect_my_mailbox')}}</button>

        </div>

    </bottom-sheet>

</template>

<script>
import BottomSheet from '../../components/bottomSheet/BottomSheet'

import Storage from '../../helpers/storage'

import Tag from '../../modules/tag'

export default {

    name: 'bottom-sheet-discovery-suggests',

    components: {BottomSheet},

    methods: {

        open() {
            this.$refs.bottomsheet.open()
            Tag.pageViewAll(this, 'demo_mode_onboarding_1')
        },

        close() {
            this.$refs.bottomsheet.close()
            this.$emit('close')
        },

        goDiscovery() {
            this.saveDiscoveryDone()
            this.$router.push(({path: '/discovery'}))
        },

        goLanding() {
            this.saveDiscoveryDone()
            this.close()
        },

        saveDiscoveryDone() {
            Storage.setItem(Storage.KEYS.IS_TUTO_DISCOVERY_DONE, true)
        }
    }

}

</script>

<style lang="scss" scoped>

.bsds {
    padding: 8px 16px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        padding: 48px 70px;
    }

    .swim {
        width: 100%;
        margin-top: 20px;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 40px;
        }
    }

}

</style>
